export function authToken() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return user.token;
    } else {
        return {};
    }
}

export const signOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("billing");
    window.location.href = "/";
};